
const contactTypes = {
  email: {
    icon: "tabler--mail-filled",
    name: "E-Mail",
    type: "email",
    sort: 1,
    hrefBuilder: v => `mailto:${v}`,
  },
  WhatsApp: {
    icon: "tabler--brand-whatsapp",
    name: "WhatsApp",
    type: "WhatsApp",
    sort: 2,
    hrefBuilder: v => `https://api.whatsapp.com/send?l=en&phone=${v}`,
  },
  Skype: {
    icon: "tabler--brand-skype",
    name: "Skype",
    type: "Skype",
    sort: 3,
    hrefBuilder: v => `skype:${v}?chat`,
  },
  wxcodeurl: {
    icon: "tabler--brand-wechat",
    name: "WeChat",
    type: "wxcodeurl",
    sort: 4,
    href: "weixin://dl/about",
    content: null,
  },
};
export default {
  props: ["wmkcData"],
  data() {
    return {
      floatData: [],
    };
  },
  created() {
    const data = [];
    const { contactShare } = this.wmkcData;
    for (const item in contactShare) {
      for (const type in contactTypes) {
        if (item === type) {
          const contactType = contactTypes[type];
          if (type === "wxcodeurl") {
            data.push({
              ...contactType,
              image: contactShare[type],
            });
          } else if (contactShare[type]) {
            const values = contactShare[type].split(",").filter(v => v);

            values.forEach(v => {
              data.push({
                ...contactType,
                href: contactType.hrefBuilder
                  ? contactType.hrefBuilder(v)
                  : contactType.href,
                content: v,
              });
            });
          }
        }
      }
    }
    data.sort((a, b) => a.sort - b.sort);

    this.floatData = data;
  },
};
